// extracted by mini-css-extract-plugin
export var active = "_co-7";
export var container = "_co-0";
export var evenWidth = "_co-4";
export var large = "_co-5";
export var outlet = "_co-8";
export var slide = "_co-2";
export var small = "_co-6";
export var tab = "_co-3";
export var tabs = "_co-1";